import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Order } from '../../order/order.model';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/index';
import { TranslateService } from '@ngx-translate/core';
import { MustMatch } from '../../shared/validators/must-match.validator';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  signupFormGroup: FormGroup;
  signupFormGroupSubs: Subscription;
  hide = true;
  hide2 = true;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translate: TranslateService) {
  }

  ngOnInit() {
    this.signupFormGroup = this.formBuilder.group({
      'email' : [null, Validators.required],
      'password' : [null, Validators.required],
      'passwordConfirm' : [null, Validators.required]
    }, {
            validator: MustMatch('password', 'passwordConfirm')
        });
    this.signupFormGroup.valueChanges.subscribe(val => {
    });
    this.route.paramMap.subscribe(params => {
      const email = params.get('email');
      console.log(email);
      this.signupFormGroup.setValue({email: email, password: null, passwordConfirm: null});
    });
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    console.log(language);

  }

  getLanguage() {
    return this.translate.currentLang;
  }

  onSubmit(form: NgForm) {
    this.authService.validateEmail('email', 'pass').subscribe(data => {
      console.log(data);
    });
    console.log(form);

  }

  onSubmitRegister() {
    const authData = {
      email: this.signupFormGroup.value.email,
      password: this.signupFormGroup.value.password
    };

    this.authService.registerUser(authData);
  }

  onSumbitNew(form: NgForm) {
    const authData = {
      email: form.value.email,
      password: form.value.password
    };
    this.authService.registerUser(authData);
  }

}
